import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { getWvBrandingSafe } from '../../services/wvBrandingConfig';
import { resolvePublicUrl } from '../../utils/publicUrl';
/**
 * One-color seal: large bottom watermark (~10% opacity), fixed lower-right; paths with spaces encoded.
 */
const LandingLowerSeal = () => {
    const seal = getWvBrandingSafe().wvStateSealOneColorPng;
    const raw = resolvePublicUrl(seal) ?? seal;
    const src = raw.replace(/ /g, '%20');
    return (_jsx(Box, { className: "cms-landing-seal", "aria-hidden": true, sx: {
            display: 'none',
            /* Hidden per design request to remove background watermark */
            position: 'fixed',
            right: { xs: 0, sm: 8, md: 12 },
            bottom: { xs: 0, sm: 8, md: 12 },
            width: { xs: 'min(92vw, 520px)', sm: 'min(72vw, 580px)', md: 'min(58vw, 640px)' },
            height: { xs: 'min(52vh, 420px)', sm: 'min(48vh, 480px)', md: 'min(44vh, 520px)' },
            zIndex: 1,
            pointerEvents: 'none',
        }, children: _jsx(Box, { component: "img", src: src, alt: "", sx: {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                objectPosition: 'right bottom',
                opacity: 0.1,
            } }) }));
};
export default LandingLowerSeal;
